import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';
import { BranchesService } from 'src/app/super-management/branch/branches.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-su-edit-lock-code',
  templateUrl: './su-edit-lock-code.component.html',
  styleUrls: ['./su-edit-lock-code.component.css'],
  host: {
    class: 'fill-screen-modal-phone'
  }
})
export class SuEditLockCodeComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;
  isLoadingUpdates = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  printingService: string;
  printerId: string;
  currentLockCode: string = '';
  newLockCode: string = '';
  isSuccessfullyUpdated: boolean = false;

  @ViewChild('myForm') myForm: NgForm;
  @ViewChild('lockCodeInput') lockCodeInput: ElementRef;

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    private branchesService: BranchesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.printingService = data.printingService;
    this.printerId = data.printerId;
    this.currentLockCode = data.currentLockCode || '';
    this.newLockCode = this.currentLockCode;
  }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    this.isLoading = false;
  }

  closeEditLockCodeDialog() {
    this.dialogService.onCloseEditLockCodeDialog();
  }

  onSubmit() {
    this.updateLockCode();
  }

  triggerFormSubmit() {
    if (this.myForm) {
      this.myForm.ngSubmit.emit();
    }
  }

  updateLockCode() {
    this.isLoadingUpdates = true;
    this.branchesService.updateLockCode(this.printingService, this.printerId, this.newLockCode).subscribe(
      response => {
        this.isSuccessfullyUpdated = true;
        this.isLoadingUpdates = false;
        // Emit event to refresh printer data
        setTimeout(() => {
          this.dialogService.onCloseEditLockCodeDialog();
          // Trigger refresh of printer data
          window.location.reload();
        }, 1300);
      },
      error => {
        console.error('Error updating lock code:', error);
        this.isLoadingUpdates = false;
      }
    );
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }
}

